import React from 'react';
import i18n from '../../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../../Form/FormField";
import FormDate from "../../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {Hidden, withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../../Form/utils";
import FormCheck from "../../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../../Form/DeleteButton";
import FormSelect from "../../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../../Media/DropButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from "@material-ui/core/Typography";
import SignatureCanvas from 'react-signature-canvas';
import FormRadio from "../../Form/FormRadio";
class ElectricalSafety extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
            signatureData1: '',
            signatureData2: '',
            updatingFields: false,
        };
    }

    sigCanvas1 = {}
    sigCanvas2 = {}

    handleSign1 = () => {
        this.setState({signatureData1: this.sigCanvas1.toDataURL()});
    }
    handleSign2 = () => {
        this.setState({signatureData2: this.sigCanvas2.toDataURL()});
    }

    render() {
        const {
            classes,
            values,
            protocol,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            customer,
            structure,
            uploadConfig,
        } = this.props;

        values.signature1 = this.state.signatureData1
        values.signature2 = this.state.signatureData2
        if(protocol && protocol.is_correction) {
            values.is_correction = true;
            values.from_protocol_id = protocol.id;
        }

        return (
            <React.Fragment>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Leistungsschild:
                    </Typography>
                </Grid>
                <Grid item xs={9}>
                    <FormRadio
                        name="nameplate"
                        options={[
                            {
                                value : 'available',
                                label : 'vorhanden',
                            },
                            {
                                value : 'not_available',
                                label : 'nicht vorhanden',
                            },
                            {
                                value : 'illegible',
                                label : 'unleserlich'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadio}
                        classNameRadio={classes.formButton}
                        onBlur={handleBlur}
                        value={values.nameplate || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Spannung:
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormField
                        type="text"
                        name="voltage"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.voltage}
                        inputProps={{
                            maxLength : 35,
                        }}
                    />
                </Grid>
                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Inventar-Nummer:
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormField
                        type="text"
                        name="number_inventar"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.number_inventar}
                        inputProps={{
                            maxLength : 35,
                        }}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Isolationswiderstand:
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormField
                        type="text"
                        name="resistor"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.resistor}
                        inputProps={{
                            maxLength : 35,
                        }}
                    />
                </Grid>
                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Betriebsstundenzähler:
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormField
                        type="text"
                        name="meter_value"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.meter_value}
                        inputProps={{
                            maxLength : 35,
                        }}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Art des Geräts:
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormField
                        type="text"
                        name="device"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.device}
                        inputProps={{
                            maxLength : 35,
                        }}
                    />
                </Grid>
                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Geräte-Nummer:
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormField
                        type="text"
                        name="number_device"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.number_device}
                        inputProps={{
                            maxLength : 35,
                        }}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Geräte-Typ:
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormField
                        type="text"
                        name="device_type"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.device_type}
                        inputProps={{
                            maxLength : 35,
                        }}
                    />
                </Grid>
                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Hersteller:
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <FormField
                        type="text"
                        name="producer"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.producer}
                        inputProps={{
                            maxLength : 35,
                        }}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Schutzklasse:
                    </Typography>
                </Grid>
                <Grid item xs={9}>
                    <FormField
                        type="text"
                        name="protection_class"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.protection_class}
                        inputProps={{
                            maxLength : 35,
                        }}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Prüfgeräte:
                    </Typography>
                </Grid>
                <Grid item xs={9}>
                    <FormField
                        type="text"
                        name="testing_devices"
                        multiline
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.testing_devices}
                        inputProps={{
                            maxLength : 35,
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        <b>Ausgeführte Arbeiten:</b>
                    </Typography>
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Schutzeinrichtung
                    </Typography>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Unbeabsichtigte Betätigung
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="guard_unintentional_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.guard_unintentional_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="guard_unintentional_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.guard_unintentional_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <b>

                    </b>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Gleichzeitigkeit
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="guard_simultaneity_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.guard_simultaneity_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="guard_simultaneity_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.guard_simultaneity_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <b>

                    </b>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Aufhebung des Steuerbefehls bei Freigabe eines Steuerteils
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="guard_command_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.guard_command_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="guard_command_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.guard_command_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <b>

                    </b>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Sicherheitsabstand
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="safety_distance_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.safety_distance_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="safety_distance_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.safety_distance_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Kontrollleuchten für Schaltzustand
                    </Typography>
                </Grid>
                <Grid item xs={5}>

                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="control_lamps_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.control_lamps_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="control_lamps_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.control_lamps_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Umstelleinrichtung
                    </Typography>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Korrekte Einstellung
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="changeover_correct_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.changeover_correct_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="changeover_correct_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.changeover_correct_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <b>

                    </b>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Zwangsläufige Einstellung
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="changeover_inevitable_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.changeover_inevitable_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="changeover_inevitable_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.changeover_inevitable_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <b>

                    </b>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Deutliche Erkennbarkeit
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="changeover_recognizable_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.changeover_recognizable_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="changeover_recognizable_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.changeover_recognizable_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Ausschalteinrichtung
                    </Typography>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Abschaltung der Steuerung
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="switch_off_device_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.switch_off_device_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="switch_off_device_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.switch_off_device_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Einrichtung gegen Absinken des Stössels
                    </Typography>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Abschaltung der Steuerung
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="pestle_switch_off_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.pestle_switch_off_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="pestle_switch_off_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.pestle_switch_off_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <b>

                    </b>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Tischtiefe > 800 mm
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="pestle_800_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.pestle_800_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="pestle_800_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.pestle_800_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <b>

                    </b>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Tischtiefe > 500 mm
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="pestle_500_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.pestle_500_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="pestle_500_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.pestle_500_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <b>

                    </b>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Einrichtung vorhanden
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="pestle_equipment_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.pestle_equipment_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="pestle_equipment_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.pestle_equipment_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Prüfung der Steuerung
                    </Typography>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Kennzeichnung
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="control_marking_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.control_marking_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="control_marking_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.control_marking_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <b>

                    </b>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Einzelhubsicherung
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="control_single_stroke_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.control_single_stroke_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="control_single_stroke_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.control_single_stroke_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <b>

                    </b>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Abschalten der Energie
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="control_switch_off_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.control_switch_off_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="control_switch_off_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.control_switch_off_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <b>

                    </b>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Drehrichtungsänderung
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="control_direction_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.control_direction_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="control_direction_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.control_direction_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <b>

                    </b>
                </Grid>
                <Grid item xs={5}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Pressensicherheitsventil
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="control_valve_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.control_valve_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="control_valve_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.control_valve_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Allgemeinzustand der Machine
                    </Typography>
                </Grid>
                <Grid item xs={5}>

                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="condition_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.condition_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="condition_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.condition_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Betriebsanweisung
                    </Typography>
                </Grid>
                <Grid item xs={5}>

                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="instruction_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.instruction_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="instruction_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.instruction_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Sichtprüfung
                    </Typography>
                </Grid>
                <Grid item xs={5}>

                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="visual_inspection_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.visual_inspection_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="visual_inspection_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.visual_inspection_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Funktionsprüfung
                    </Typography>
                </Grid>
                <Grid item xs={5}>

                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="functional_inspection_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.functional_inspection_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="functional_inspection_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.functional_inspection_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Steckverbindungen
                    </Typography>
                </Grid>
                <Grid item xs={5}>

                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="connectors_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.connectors_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="connectors_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.connectors_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Kabel/Leitungen
                    </Typography>
                </Grid>
                <Grid item xs={5}>

                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="cables_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.cables_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="cables_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.cables_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Batterie Zustand
                    </Typography>
                </Grid>
                <Grid item xs={5}>

                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="battery_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.battery_tested || ''}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="battery_okay"
                        options={[
                            {
                                value : 'okay',
                                label : 'i.O.'
                            },
                            {
                                value : 'not_okay',
                                label : 'n.i.O.'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.battery_okay || ''}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Akkuladespannung
                    </Typography>
                </Grid>
                <Grid item xs={5}>

                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="charging_voltage_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.charging_voltage_tested || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                </Grid>
                <Grid item xs={1}>
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Prüfplakette angebracht
                    </Typography>
                </Grid>
                <Grid item xs={5}>

                </Grid>
                <Grid item xs={2}>
                    <FormRadio
                        name="inspection_tested"
                        options={[
                            {
                                value : 'yes',
                                label : 'Ja'
                            },
                            {
                                value : 'no',
                                label : 'Nein'
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadioSelection}
                        classNameRadio={classes.formSelection}
                        onBlur={handleBlur}
                        value={values.inspection_tested || ''}
                    />
                </Grid>
                <Grid item xs={1}>
                </Grid>
                <Grid item xs={1}>
                </Grid>

                <Grid item xs={3}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Bemerkungen:
                    </Typography>
                </Grid>
                <Grid item xs={9}>
                    <FormField
                        type="text"
                        name="notations"
                        multiline
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.notations}
                    />
                </Grid>


                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Datum:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="current_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.current_date}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Nächster Prüftermin:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="next_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.next_date}
                    />
                </Grid>

                <Hidden smDown>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas1 = ref }}
                                    onEnd={this.handleSign1}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas2 = ref }}
                                    onEnd={this.handleSign2}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Auftraggeber
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Prüfer
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                </Hidden>

                <Hidden mdUp>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas1 = ref }}
                            onEnd={this.handleSign1}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Auftraggeber
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>&nbsp;</Grid>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas2 = ref }}
                            onEnd={this.handleSign2}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Prüfer
                        </Typography>
                    </Grid>
                </Hidden>
            </React.Fragment>
        )
    }
}

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    },
    textLeft: {
        textAlign: "left",
    },
    textCenter: {
        textAlign: "center",
    },
    textRight: {
        textAlign: "right",
    },
    formRadio: {
        flexDirection: "row",
        marginLeft: '-200px',
    },
    formRadioSelection: {
        flexDirection: "row",
    },
    formButton: {
        marginLeft: '200px'
    },
    formSelection: {
    }
});

export default withStyles(styles)(ElectricalSafety)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Protocols/Protocols/ElectricalSafety.js